import { render, staticRenderFns } from "./archivesFamily.vue?vue&type=template&id=c1b889d2&scoped=true&"
import script from "./archivesFamily.vue?vue&type=script&lang=js&"
export * from "./archivesFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b889d2",
  null
  
)

export default component.exports